export const MAX_RETRY_ATTEMPTS = 7;
export const RETRY_WARNING_THRESHOLD = 3;
